
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CertificateHelperDialog extends Vue {
	@Prop()
	private certificateHelperDialog!: boolean;

	private closeDialog() {
		this.$emit("closeDialog");
	}

	private checkEsc(keyPress: KeyboardEvent) {
		if (keyPress.key === "Escape") {
			this.closeDialog();
		}
	}
}
